var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "default-layout",
    {
      attrs: {
        title: _vm.t("ResetPasswordSentPage.pageTitle"),
        "sub-title": _vm.t("ResetPasswordSentPage.subTitle"),
      },
    },
    [
      _c(
        "sm-button",
        {
          staticClass: "reset-password-link",
          attrs: { type: "primary", to: { name: "ResetPasswordPage" } },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.t("ResetPasswordSentPage.resendEmailLink")) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.loginHelpUrl
        ? _c("div", { staticClass: "login-support" }, [
            _c(
              "a",
              {
                staticClass: "login-help-url",
                attrs: {
                  href: _vm.localisedHelpUrl || _vm.loginHelpUrl,
                  target: "_blank",
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.t("ResetPasswordSentPage.troubleLoggingInLink")
                    ) +
                    "\n    "
                ),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }